"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    getBoundingBox: function() {
        return getBoundingBox;
    },
    getCoordinates: function() {
        return getCoordinates;
    },
    getScaleOffset: function() {
        return getScaleOffset;
    }
});
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function getScaleOffset(// ir coordinate space -->
irWidth = 320, irHeight = 240, // pip coordinate space -->
pipWidth = 400, pipHeight = 300, // canvas coordinate space -->
outputWidth = 640, outputHeight = 480, isPipEnabled = true) {
    // compute the scale and offset -->
    return {
        scale: isPipEnabled ? {
            // PIP: TRUE
            x: pipWidth / irWidth,
            y: pipHeight / irHeight
        } : {
            // PIP: FALSE
            x: outputWidth / irWidth,
            y: outputHeight / irHeight
        },
        offset: isPipEnabled ? {
            // PIP: TRUE
            x: (outputWidth - pipWidth) / 2,
            y: (outputHeight - pipHeight) / 2
        } : {
            // PIP: FALSE
            x: 0,
            y: 0
        }
    };
}
function getCoordinates(point = {}, scaleOffset = {}, toCanvas = true) {
    const { x, y } = point;
    const { scale = {
        x: 1,
        y: 1
    }, offset = {
        x: 0,
        y: 0
    } } = scaleOffset;
    return toCanvas === true ? {
        // converting coordinates to display coordinates
        x: Math.round(x * scale.x + offset.x),
        y: Math.round(y * scale.y + offset.y)
    } : {
        // converting from display coordinates to backend
        x: Math.round((x - offset.x) / scale.x),
        y: Math.round((y - offset.y) / scale.y)
    };
}
function getBoundingBox(points = []) {
    let upperLeft = _object_spread({}, points[0]);
    let lowerRight = _object_spread({}, points[0]);
    for(let i = 1; i < points.length; i++){
        upperLeft = {
            x: Math.min(upperLeft.x, points[i].x),
            y: Math.min(upperLeft.y, points[i].y)
        };
        lowerRight = {
            x: Math.max(lowerRight.x, points[i].x),
            y: Math.max(lowerRight.y, points[i].y)
        };
    }
    return [
        upperLeft,
        lowerRight
    ];
}
